import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  counterMenu: {
    display: 'flex',
    alignItems: 'center',
    '& label': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
      lineHeight: '125%',
    },
    [Theme.breakpoints.down('sm')]: {
      '& label': {
        fontSize: Theme.typography.size[2],
        lineHeight: '150%',
      },
    },
    '& .MuiLink-button': {
      margin: '0 0 2px 0',
      fontSize: Theme.typography.size[1],
      fontFamily: Theme.typography.base.regular,
      color: Theme.palette.primary.light,
      lineHeight: '125%',
      alignItems: 'center',

      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
  },
  dropLabel: {
    padding: '0',
    marginLeft: '24px',
    height: 'auto',
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: Theme.palette.primary.light,
    textTransform: 'capitalize',
    fontSize: Theme.typography.size[1],
    fontFamily: Theme.typography.base.regular,
    '& svg': {
      marginLeft: '4px',
      width: '24px',
      height: '24px',
    },
  },
  menu: {
    padding: '20px',
  },
  paper: {
    backgroundColor: Theme.palette.white,
    [Theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 40px)',
      left: '20px !important',
    },
  },

  wrapperCounter: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      fontFamily: Theme.typography.base.regular,
      marginBottom: 30,
      marginRight: 40,
    },
    '& span': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[8],
      lineHeight: Theme.typography.size[10],
    },
  },
  counter: {
    display: 'flex',
    width: 150,
    height: 72,
    alignItems: 'center',
    marginBottom: 30,
    float: 'right',
    backgroundColor: Theme.palette.gray[100],
    '& svg': {
      fill: Theme.palette.primary.light,
    },
  },
  footerMenu: {
    textAlign: 'right',
  },

  disabledButton: {
    backgroundColor: `${Theme.palette.gray[100]} !important`,
    '& svg': {
      fill: Theme.palette.gray[400],
    },
  },
}));

export default useStyles;
